export const appleOutline = <svg version="1.1" id="Layer_1"
  viewBox="0 0 384 512"><g>
    <path d="M278,174.1c1.1,0,2.2,0,3.3,0.1l0,0l0,0c13.1,1,24.6,3.9,34.1,8.5c-5.5,6.2-10.4,12.7-14.5,19.6
		c-11.5,19.4-17.3,41.6-17.2,66c-0.2,9.5,0.7,28.4,9.6,50.2c9,22.3,23.8,41.4,43.5,56.4c-6.1,12.7-13.8,26.4-22.4,38.5
		c-16.4,22.9-30.1,31.3-36.8,31.5c-6.6-0.1-12.7-2.3-22.8-6.2c-13.5-5.2-30.4-11.7-53.3-11.7c-24.2,0-41.8,6.7-56,12.1
		c-8.4,3.2-15,5.7-20.6,5.8l-0.1,0l-0.1,0l-0.1,0c-3.7,0-17.7-6.1-37.6-34.2c-16-22.5-29.5-50.8-35.3-67.5
		C43.2,319.1,39,295.7,39,273.5c0-31.4,9.2-57.3,26.5-74.9c14.2-14.4,33.8-22.8,53.8-23.3c9.4,0.1,24.4,5.5,36.5,9.9
		c14.5,5.3,27.1,9.8,39.6,9.8c11.4,0,22.3-4,36.1-9.1C245.9,180.6,263.5,174.1,278,174.1 M278,139.1c-33.8,0-69.1,20.9-82.5,20.9
		c-15,0-49.4-19.7-76.4-19.7C63.3,141.2,4,184.8,4,273.5c0,26.2,4.8,53.3,14.4,81.2c12.7,36.4,58.2,125.2,106,125.2
		c0.4,0,0.8,0,1.2,0c25.2-0.6,43-17.9,75.8-17.9c31.8,0,48.3,17.9,76.4,17.9c48.6-0.7,90.4-82.5,102.6-119.3
		c-65.2-30.7-61.7-90-61.7-91.9c-0.2-36.7,16.4-64.4,50-84.8c-18.8-26.9-47.2-41.7-84.7-44.6C282,139.1,280,139.1,278,139.1
		L278,139.1z"/></g>
  <path d="M262.1,104.5c27.3-32.4,24.8-61.9,24-72.5c-24.1,1.4-52,16.4-67.9,34.9c-17.5,19.8-27.8,44.3-25.6,71.9
	C218.7,140.8,242.5,127.4,262.1,104.5z"/>
</svg>
